import { createUseStyles } from 'react-jss';

const styles = {
  dropdownButton: {
    fontWeight: 700,
    padding: '0 1rem',
    fontSize: '1.6rem',
    lineHeight: '2.6rem',
    height: '4.3rem',
  },
  dropdownOpenedBtn: {
    border: '2px solid transparent',
  },
  dropdownOption: { padding: '1.6rem' },
};

const createStyles = createUseStyles(styles);

export { createStyles };
